import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal-blocker"
export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this.hide()
  }

  disconnect() {
    this.hide()
  }

  show() {
    if (!this.hasOverlayTarget) return

    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.setAttribute("aria-hidden", "false")
  }

  hide() {
    if (!this.hasOverlayTarget) return

    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.setAttribute("aria-hidden", "true")
  }
}
